import {Injectable} from '@angular/core';
import {ParentService} from "./ParentService";
import {ExamEntity} from "../model/ExamEntity";
import {Shared} from "../view/shared/shared";
import {EstimationSettingsEntity} from "../model/EstimationSettingEntity";

@Injectable()
export class PlacesService extends ParentService{

  public getPlaces(year, corpId) {
    return this.http.get(this.shared.MAGNAMENT_URL+'/getPlaces/'+corpId+'/'+year, this.shared.headers());
  }
  public filterPlacesByPage(filterObject, position, exponential, corpId) {
    return this.http.post(this.shared.MAGNAMENT_URL+'/filterPlacesByPage/'+position+'/'+exponential+'/'+corpId, filterObject, this.shared.headers());
  }
}
